export class UploadFile {
    constructor(documentRepository) {
      this.documentRepositor = documentRepository;
    }
  
    async execute(uploadrequest) {
      return await this.documentRepositor.uploadFile(uploadrequest);
    }
  }